import { Component, OnInit, Input} from '@angular/core';
import { Cliente } from '../../cliente/cliente.model';

@Component({
  selector: 'app-usuario-datos-cuenta',
  templateUrl: './usuario-datos-cuenta.component.html',
  styleUrls: ['./usuario-datos-cuenta.component.scss']
})
export class UsuarioDatosCuentaComponent implements OnInit {

  @Input() cliente: Cliente;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-cuenta/usuario-datos-cuenta.component.ts